module.exports = {
  api_baseurl: process.env.REACT_APP_API_BASEURL,
  base_color: "#497458",
  bar_chart: {
    max_hour_per_day: 15,
    day_period: 10,
  },
};
